<template>
    <div class="k-barcode">
        <svg ref="barcode"></svg>
    </div>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
    name: 'Barcode',
    props: {
        value: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
        this.generateBarcode();
    },
    watch: {
        value() {
            this.generateBarcode();
        }
    },
    methods: {
        generateBarcode() {
            JsBarcode(this.$refs.barcode, this.value, this.options);
        }
    }
};
</script>
